import { createActions } from 'redux-actions';

import types from 'state/direct-order-recurring/days/actionTypes';

const { directOrderRecurring } = createActions({
  [types.SET_DAY]: ({ day }) => ({ day }),
});

export default directOrderRecurring;
